import { jsx, jsxs } from "react/jsx-runtime";
import {
  Table as MuiTable,
  Paper,
  styled,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from "@mui/material";
import { Control } from "./Control.js";
function TableControls(props) {
  const { state, setField, options: { tableSx } = {} } = props;
  return /* @__PURE__ */ jsx(TableContainer, { component: Paper, children: /* @__PURE__ */ jsxs(Table, { size: "small", sx: tableSx, children: [
    /* @__PURE__ */ jsx(TableHead, { children: /* @__PURE__ */ jsxs(TableRow, { children: [
      /* @__PURE__ */ jsx(TableCell, { children: "Property" }),
      /* @__PURE__ */ jsx(TableCell, { children: "Value" })
    ] }) }),
    /* @__PURE__ */ jsx(TableBody, { children: Object.entries(state).map(([fieldName, field]) => {
      const hidden = field.hidden?.(state) ?? false;
      return /* @__PURE__ */ jsxs(
        TableRow,
        {
          sx: {
            "&:last-child td, &:last-child th": { border: 0 },
            display: hidden ? "none" : void 0
          },
          children: [
            /* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(Tooltip, { arrow: true, placement: "top", title: field.description, children: /* @__PURE__ */ jsx("span", { children: field.label ?? fieldName }) }) }),
            /* @__PURE__ */ jsx(TableCell, { children: /* @__PURE__ */ jsx(Control, { field, id: fieldName, setField, state }) })
          ]
        },
        fieldName
      );
    }) })
  ] }) });
}
const Table = styled(MuiTable)(({ theme }) => ({
  my: theme.spacing(1),
  userSelect: "none"
}));
export {
  TableControls
};
//# sourceMappingURL=TableControls.js.map
